import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import useNextPublicChallenge from '../../hooks/useNextPublicChallenge';
import { EducationDesignPreview } from '../education/EducationDesignExperiment';
import ChallengeClarityPaint from './ChallengeClarityPaint';
import ChallengePage from './ChallengePage';
import '../education/EducationControlRoom.css';
import './ChallengePageControlRoom.css';
import './ChallengePageClarity.css';

/** The live slug the user asked to restyle. Used when no upcoming run exists. */
export const CHALLENGE_CLARITY_REVIEW_SLUG = 'september-2026-7-day-ai-trading-challenge';

/**
 * Review route: /challenges-clarity and /challenges-clarity/:slug.
 * Mounts the full PostHog test (control_room) ChallengePage with Clarity paint.
 * Does not evaluate or enroll challenge_page_control_refined_clarity_2026_08_31.
 */
export default function ChallengeClarityReview(): React.ReactElement {
  const { slug } = useParams<{ slug?: string }>();
  const location = useLocation();
  const { challenge } = useNextPublicChallenge();
  const resolvedSlug = slug || challenge?.slug || CHALLENGE_CLARITY_REVIEW_SLUG;

  if (!slug) {
    return (
      <Navigate
        to={`/challenges-clarity/${resolvedSlug}${location.search}${location.hash}`}
        replace
      />
    );
  }

  return (
    <div
      className="challenge-clarity-review education-design-experiment education-design-experiment--control-room education-design-experiment--clarity"
      data-testid="challenge-clarity-review"
      data-education-design-variant="clarity"
      data-education-theme="dark"
      data-education-theme-source="review"
      data-experiment-active="false"
    >
      <EducationDesignPreview variant="clarity">
        <ChallengePage />
      </EducationDesignPreview>
      <ChallengeClarityPaint rootSelector='[data-testid="challenge-clarity-review"]' />
    </div>
  );
}
